import FullPageLayout from '@/components/productPageComponents/fullPageLayout';
import type { IMultipleFeaturesWithDescAndPic } from '@/utils/const/products/interface';
import { Tabs } from 'antd';
import { useEffect, useRef, useState } from 'react';
import SFullPage from './style.module.scss';
import { WebPNextImage as Image } from '@/components/WebPImage';
import { useUserAgentInfo } from '@/context/user-agent';
import CollapseForMobile from './CollapseForMobile';

interface FullPageTabProps {
  data: IMultipleFeaturesWithDescAndPic;
}
const FullPageTab = ({ data }: FullPageTabProps) => {
  const { isMobile } = useUserAgentInfo();

  const [active, setActive] = useState<number>(0);
  const paused = useRef<boolean>(false);

  const { title, items } = data;

  useEffect(() => {
    const intervalId = setInterval(() => {
      if (paused.current) {
        paused.current = false;
        return;
      }
      setActive((prev) => {
        if (prev === items.length - 1) {
          return 0;
        }
        return prev + 1;
      });
    }, 5000);
    return () => {
      clearInterval(intervalId);
    };
  }, []);

  return (
    <FullPageLayout title={title} className={SFullPage['background']}>
      {!isMobile ? (
        <Tabs
          activeKey={String(active)}
          onChange={(key) => {
            setActive(Number(key));
            paused.current = true;
          }}
          centered
          className={SFullPage['tabs']}
          animated={{ inkBar: true, tabPane: true }}
        >
          {items.map((item, index) => {
            const { title, subTitle, picUrl } = item;
            return (
              <Tabs.TabPane
                className={SFullPage['tab-container']}
                tab={title}
                key={index}
              >
                <main className={SFullPage['pane-container']}>
                  <section className={SFullPage['text-section']}>
                    <div className={SFullPage['title']}>{title}</div>
                    <div className={SFullPage['desc']}>{subTitle}</div>
                  </section>
                  <section className={SFullPage['image-section']}>
                    <Image src={picUrl} layout="fill" alt={title} />
                  </section>
                </main>
              </Tabs.TabPane>
            );
          })}
        </Tabs>
      ) : (
        <CollapseForMobile list={items} />
      )}
    </FullPageLayout>
  );
};

export default FullPageTab;
